export default __webpack_public_path__ + "static/media/051-pyramid.2fe0afef.svg";